import {
  LayoutDashboard,
  Calendar,
  PlusCircle,
  Settings,
  LogOut,
  BarChart3,
  Wrench,
  Users,
  DollarSign,
  MessageCircle,
  ChevronLeft,
  Home,
} from 'lucide-react';
import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';

import { useAuth } from './Auth/AuthContext';
import './HostLayout.css';

const HostLayout = () => {
  const { user, logout, profile } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const menuItems = [
    {
      path: '/host',
      label: 'Dashboard',
      icon: LayoutDashboard,
      exact: true,
    },
    {
      path: '/host/messages',
      label: 'Messages',
      icon: MessageCircle,
    },
    {
      path: '/host/events',
      label: 'My Events',
      icon: Calendar,
    },
    {
      path: '/host/events/create',
      label: 'Create Event',
      icon: PlusCircle,
    },
    {
      path: '/host/tools',
      label: 'Host Tools',
      icon: Wrench,
    },
    {
      path: '/host/analytics',
      label: 'Analytics',
      icon: BarChart3,
    },
    {
      path: '/host/attendees',
      label: 'Attendees',
      icon: Users,
    },
    {
      path: '/host/payouts',
      label: 'Payouts',
      icon: DollarSign,
    },
    {
      path: '/host/settings',
      label: 'Settings',
      icon: Settings,
    },
  ];

  return (
    <div className="host-layout">
      <aside className="host-sidebar">
        <div className="host-sidebar-header">
          <div className="host-logo">
            <Home className="host-logo-icon" />
            <span className="host-logo-text">Host Portal</span>
          </div>
          <button onClick={() => navigate('/home')} className="host-back-btn">
            <ChevronLeft size={20} />
            Back to Site
          </button>
        </div>

        <nav className="host-nav">
          {menuItems.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.exact}
                className={({ isActive }) => `host-nav-item ${isActive ? 'active' : ''}`}
              >
                <Icon size={20} />
                <span>{item.label}</span>
              </NavLink>
            );
          })}
        </nav>

        <div className="host-sidebar-footer">
          <div className="host-user-info">
            <div className="host-user-avatar">
              {profile?.display_name?.[0]?.toUpperCase() || user?.email?.[0]?.toUpperCase() || 'H'}
            </div>
            <div className="host-user-details">
              <div className="host-user-name">
                {profile?.display_name || user?.email?.split('@')[0] || 'Host User'}
              </div>
              <div className="host-user-role">Event Host</div>
            </div>
          </div>
          <button onClick={handleLogout} className="host-logout-btn">
            <LogOut size={18} />
            Logout
          </button>
        </div>
      </aside>

      <main className="host-main">
        <Outlet />
      </main>
    </div>
  );
};

export default HostLayout;
